module.exports = __webpack_public_path__ + "e03922edb26341d5f64778d1b17eade5.svg";